.Section {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--bs-border-color);
  background: white;
}
